import { render, staticRenderFns } from "./ReferencialModalComponent.vue?vue&type=template&id=131d9248&"
import script from "./ReferencialModalComponent.vue?vue&type=script&lang=js&"
export * from "./ReferencialModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports